module.exports = __webpack_public_path__ + "static/seveneves-5a727e1abac8eadc952530aa07e6c839.jpg";